var map = {
	"./power-level-0.png": "7dc2",
	"./power-level-1.png": "00b3",
	"./power-level-2.png": "afb5",
	"./power-level-3.png": "bb41",
	"./power-level-4.png": "9635",
	"./power-level-5.png": "1854",
	"./power-level-6.png": "7a3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4dc9";